import { render, staticRenderFns } from "./DetalhesPCM.vue?vue&type=template&id=84bf3cbc"
import script from "./DetalhesPCM.vue?vue&type=script&lang=js"
export * from "./DetalhesPCM.vue?vue&type=script&lang=js"
import style0 from "./DetalhesPCM.vue?vue&type=style&index=0&id=84bf3cbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports